import Repre from '~/scripts/services/model/repre';

// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevRepreController {
	/* @ngInject */
	constructor() {
		/** @type {import('~/scripts/services/model/repre').default[]} */
		this.data = [
			new Repre({
				type: 'K_NODE;STRING',
				value: 'test1',
				readOnly: false,
			}),
		];

		this.jsonEditorOptions = {
			mode:  'code',
			modes: [
				'code',
				'form',
				'text',
				'tree',
				'view',
			],
		};

		this.settings = {
			validate: {
				rules:                {
					'K_NODE;UNIV_LANG': {
						required: true,
					},
					'K_NODE;SQL':       {
						pattern:  '[a-z][a-z0-9_]*',
						required: true,
					},
				},
			},
			add:      true,
			insert:   true,
		};

		this.myForm = {};
		this.readOnly = false;
		this.add = true;
		this.readOnly = false;

		/** @type {any[]} */
		this.roData = [...this.data];
	}

	changeValue() {
		this.roData = this.data.map(repre => repre.export());
	}
}
